import SBEditable from "../../../components/sbEditable/sbEditable"

import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"
import { RenderStoryblokComponent } from "../../../helpers/bloksRenderer"

import styles from "./columnsSimpleWidget.module.scss"

/// Blok:columnssimplewidget
// items:blok
// layout:string
///
function ColumnsSimpleWidget({ blok, story_language }) {
  const cols = GetColumnWidthsFromLayoutKey(blok.layout)

  return (
    <SBEditable blok={blok} withClass={ArticlePanelOptionsToClasses(blok)}>
      <div className={styles.colcontainer}>
        {cols.map((columnClasses,idx)=>{
          if(!blok || !blok.items || blok.items.length-1 < idx) {
            return undefined
          }
          let item = blok.items[idx]
          if(!item) { return undefined }
          return (
            <div key={item._uid} className={columnClasses}>
              {RenderStoryblokComponent(item,null,story_language)}
            </div>
          )
        })}
      </div>
    </SBEditable>
  )
}

function GetColumnWidthsFromLayoutKey(key) {
  let keys = []
  switch (key) {
    case "2-25-75":
      keys = [3,9]
      break
    case "2-33-66":
      keys = [4,8]
      break
    case "2-50-50":
      keys = [6,6]
      break
    case "2-66-30":
      keys = [8,4]
      break
    case "2-75-25":
      keys = [9,3]
      break
    case "3-30-30-30":
      keys = [4,4,4]
      break
    case "4-25-25-25-25":
      keys = [3,3,3,3]
      break
    default:
      keys = [6,6]
      break
  }

  return keys.map((key)=>{
    const desktopclass = styles[`colmd${key}`]
    return styles.col12 + " " + desktopclass
  })
}


export default ColumnsSimpleWidget